import { createFileRoute } from "@tanstack/react-router";
import { useCallback, useRef, useState } from "react";
import CspLocatorPanel, {
    NearbyCsp,
} from "@/components/csp-locator/CspLocatorPanel";
import CspLocatorMap from "@/components/csp-locator/CspLocatorMap";
import sentryNetworkLogo from "@/assets/images/Sentry_Network_Logo.png";

export const Route = createFileRoute("/public-csp-locator")({
    component: RouteComponent,
});

function RouteComponent() {
    const [selectedCspId, setSelectedCspId] = useState<number | null>(null);
    const [coords, setCoords] = useState<{ lat: number; lon: number } | null>(
        null,
    );
    const [allCsps, setAllCsps] = useState<NearbyCsp[]>([]);
    const cardRefs = useRef<Map<number, HTMLDivElement>>(new Map());

    const handleCspClick = useCallback((csp: NearbyCsp) => {
        setSelectedCspId((prev) =>
            prev === csp.organization.id ? null : csp.organization.id,
        );
    }, []);

    const handleSearchResult = useCallback(
        (data: {
            coords: { lat: number; lon: number } | null;
            eliteCsps: NearbyCsp[];
            defaultCsps: NearbyCsp[];
        }) => {
            setCoords(data.coords);
            setAllCsps([...data.eliteCsps, ...data.defaultCsps]);
            setSelectedCspId(null);
        },
        [],
    );

    return (
        <div className="flex flex-col md:flex-row w-screen h-screen">
            <div className="h-[500px] shrink-0 md:h-full md:order-2 md:flex-1 bg-gray-200">
                <CspLocatorMap
                    csps={allCsps}
                    coords={coords}
                    selectedCspId={selectedCspId}
                    setSelectedCspId={setSelectedCspId}
                    cardRefs={cardRefs}
                />
            </div>
            <div className="w-full md:w-2/5 overflow-y-auto md:order-1 bg-white">
                <div className="overflow-y-auto pt-2 px-2 flex flex-col items-center">
                    {window.self === window.top ? (
                        <img src={sentryNetworkLogo} className="w-80 " />
                    ) : null}
                    <CspLocatorPanel
                        isPublic
                        selectedCspId={selectedCspId}
                        onCspClick={handleCspClick}
                        onSearchResult={handleSearchResult}
                        cardRefs={cardRefs}
                    />
                </div>
            </div>
        </div>
    );
}
